import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "content-grid" }
const _hoisted_2 = { class: "content-grid__header" }
const _hoisted_3 = { class: "back-link-title" }

import MemberActivities from '@/components/members/MemberActivities.vue';

import {useI18n} from "vue3-i18n";


export default /*#__PURE__*/_defineComponent({
  __name: 'MemberActivitiesView',
  setup(__props) {

const {t} = useI18n()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h1", _hoisted_3, _toDisplayString(_unref(t)(`routes.activities.name`)), 1)
    ]),
    _createVNode(MemberActivities)
  ]))
}
}

})